import { createFileRoute } from "@tanstack/react-router";
import { PortalSignInPageContent } from "@/components/portal/PortalSignInPageContent";

export const Route = createFileRoute("/portal_/sign-in")({
  component: PortalSignInPage,
});

function PortalSignInPage() {
  return <PortalSignInPageContent />;
}
